export default {
  baseUrl: "https://ohws.prospective.ch/public/v1/medium/1000003",

  jobAboSubscriptionFormUrl:
      "https://ohws.prospective.ch/public/v1/careercenter/1000003/createJobAbo",

  jobsPageSize: 9,

  enableFavourites: false, // enable the favourites feature

  localStorageKeyFavourites: "prospective-jobs-favourites", // key for local storage

  jobGrid: true, // enable the job grid view

  jobGridColumns: 3, // number of columns for the job grid view (lg and up)

  autoSubmit: true, // if true, the filters will be submitted automatically when changed


  /**
   * TODO
   * Please add your filters and ids here, as defined for the project.
   * Your components will be able to access these ids via Settings.filterIds['Your filter Name'] or FILTER['Your name']
   */
  filterIds: {
    Berufsgruppe: 10,
    KlinikBereich: 20,
    Arbeitsort: 30,
  },
};
